import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_GET_CART_COUNT}`;

export const getCartCount = () => axios.get(API_PATH);
